import { createSvgIcon } from "@mui/material";

export const VideoIcon = createSvgIcon(
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M9.45996 10.8008C9.46025 10.4151 9.87871 10.1748 10.2119 10.3691L15.2822 13.3271C15.6126 13.5202 15.6127 13.9975 15.2822 14.1904L10.2119 17.1484C9.87884 17.3425 9.4605 17.1022 9.45996 16.7168V10.8008Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5625 3.25C20.4375 3.25 22 4.8125 22 6.6875V17.3125C22 19.2266 20.4375 20.75 18.5625 20.75H5.4375C3.52344 20.75 2 19.2266 2 17.3125V6.6875C2 4.8125 3.52344 3.25 5.4375 3.25H18.5625ZM3.25 17.3125C3.25 18.5234 4.22656 19.5 5.4375 19.5H18.5625C19.7344 19.5 20.75 18.5234 20.75 17.3125V8.18945H3.25V17.3125ZM5.4375 4.5C4.22656 4.5 3.25 5.51562 3.25 6.6875V6.93945H5.05078L6.45898 4.5H5.4375ZM6.49316 6.93945H10.5498L11.958 4.5H7.90137L6.49316 6.93945ZM17.4932 6.93945H20.75V6.6875C20.75 5.62477 19.9143 4.69313 18.8848 4.52832L17.4932 6.93945ZM11.9922 6.93945H16.0508L17.459 4.5H13.4004L11.9922 6.93945Z"
      fill="currentColor"
    />
  </svg>,
  "VideoIcon",
);
